import React, { useState,useEffect } from "react";

import { API_URL,RESPONSE_SUCCESS,VALID_STRING_PATTERN,INPUT_TEXT_LIMIT,VALID_EMAIL_PATTERN,PASSWORD_MIN_LENGTH,PASSWORD_MAX_LENGTH } from './../../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import HeaderLayout from "./../../Layout/Header";
import { useForm } from "react-hook-form";
import API from './../../Api';
import { toast } from 'react-toastify';
import { ROUTE_MY_PROFILE } from '../../RouteConstents';
import * as trans from '../../FrontMessages';
import ShowError from "../../Elements/ShowError.js";
import jwt_decode from "jwt-decode";

const ProfilePage = () => {

    const navigate = useNavigate();

    const { string } = useParams();

    const {register, handleSubmit, formState: { errors }, setValue } = useForm();
    
    const [fullName, setFullName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
   // const [phone, setPhone] = useState('');

    const [userName, setUserName] = useState('');
    const [phone, setPhone] = useState('');
    const [courseName, setCourseName] = useState('');
    const [batchName, setBatchName] = useState('');
    const [batchExpired, setBatchExpired] = useState('');


    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    useEffect(
        () => {
            document.body.classList.add('theme-red');
            document.body.classList.remove('overlay-open');
            getProfileInfo()

    },[true]);
    
    const getProfileInfo = async (request) => {

        let userToken = JSON.parse(localStorage.getItem('userInfo'));
        
        let userInfo =  jwt_decode(userToken)    

        setUserName(userInfo.full_name);
        setPhone(userInfo.phone);
        setCourseName(userInfo.course_name);
        setBatchName(userInfo.batch_name);
        setBatchExpired(userInfo.batch_expired);

    }
    
    const onSubmit = async (data) => {

        let formPassword = data.password;
        let formcPassword = data.confirmPassword;

        if(formPassword != '' && formcPassword != '' && formPassword != formcPassword) {
            toast.error('Password and confirm password does not match.');     
            return false;
        }

        let objValue =  {
            "method_name":"updateProfile",
            "first_name": data.firstName,
            "last_name": data.lastName,
            "password": data.password,
            "confirm_password": data.confirmPassword
        }

        await API.post(API_URL,objValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status === "success") {
                    toast.success(response.data.message); 
                    localStorage.setItem("userInfo", JSON.stringify(response.data.userInfo));
                    navigate(ROUTE_MY_PROFILE);
                } else {
                   toast.error(response.data.message); 
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
        });
        
    }
    
    return (
        <>
            <HeaderLayout />
            <section className="content">
                <div className="container-fluid">
                    <div className="block-header">
                        <h2>Profile</h2>
                    </div>
                    <div className="profile-page">
                        <div className="card ">
                            <div className="body">
                                
                                <div className="box_name">
                                    <div className="image-area">MK</div>
                                    <div className="name-area">{userName}</div>  
                                </div>
                                
                                <div className="profile-info">
                                    <div className="form-line">Phone</div>
                                    <div className="form-value">{phone}</div>   
                                </div>

                                <div className="profile-info">
                                    <div className="form-line">Course</div>
                                    <div className="form-value">{courseName}</div>   
                                </div>

                                <div className="profile-info">
                                    <div className="form-line">Batch</div>
                                    <div className="form-value">{batchName}</div>   
                                </div>

                                <div className="profile-info">
                                    <div className="form-line">Batch Expired On</div>
                                    <div className="form-value">{batchExpired}</div>   
                                </div>
                               

                               
                            </div>
                        </div>            
                                    

                                    
                        <div className="card ">
                            <div className="body">
                                <h2 className="change_password">Change Password</h2>
                                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">

                                    <div className="input-group">
                                        <div className="form-line">
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                name="password"
                                                placeholder="Password" 
                                                onChange={(e) => setPassword(e.target.value)}
                                                {...register("password",{ 
                                                    required: true,
                                                    minLength: {
                                                        value: PASSWORD_MIN_LENGTH,
                                                        message: trans.PLEASE_ENTER_PASSWORD_LENGTH
                                                    },
                                                    maxLength: {
                                                        value: PASSWORD_MAX_LENGTH,
                                                        message: trans.PLEASE_ENTER_PASSWORD_LENGTH
                                                    } 
                                                })}
                                            />
                                        </div>
                                        <ShowError errorsModal={errors.password} />
                                    </div>

                                    <div className="input-group">
                                        <div className="form-line">
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                name="confirmPassword"
                                                placeholder="Confirm Password" 
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                {...register("confirmPassword",{ 
                                                    required: true,
                                                    minLength: {
                                                        value: PASSWORD_MIN_LENGTH,
                                                        message: trans.PLEASE_ENTER_CONFIRM_PASSWORD_LENGTH
                                                    },
                                                    maxLength: {
                                                        value: PASSWORD_MAX_LENGTH,
                                                        message: trans.PLEASE_ENTER_CONFIRM_PASSWORD_LENGTH
                                                    }   
                                                })}
                                            />
                                        </div>
                                        <ShowError errorsModal={errors.confirmPassword} />
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-12 text-center">
                                            <button className="btn btn-block btn-primary waves-effect" type="submit">Update Password</button>
                                        </div>
                                    </div>
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>        
        </>
    );
   
}
    
export default ProfilePage;